/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipping_No_ServiceInputs */

const vi_error_shipping_no_service = /** @type {(inputs: Error_Shipping_No_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viettel Post không có dịch vụ giao cho tuyến này; nhân viên sẽ báo phí ship sau.`)
};

/**

* @param {Error_Shipping_No_ServiceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shipping_no_service = /** @type {((inputs?: Error_Shipping_No_ServiceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipping_No_ServiceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shipping_no_service(inputs)
});